import React, { useEffect, useRef } from 'react';
import { useLiveLogStore } from '../store/liveLogStore';
import './LiveLog.css';

const LiveLog: React.FC = () => {
  const messages = useLiveLogStore((state) => state.messages);
  const isVisible = useLiveLogStore((state) => state.isVisible);
  const toggleVisible = useLiveLogStore((state) => state.toggleVisible);
  const messagesEndRef = useRef<HTMLDivElement>(null);

  // Auto-scroll to bottom when new messages arrive
  useEffect(() => {
    if (isVisible) {
      messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
    }
  }, [messages, isVisible]);

  // Always show toggle button, but only show messages when visible
  if (messages.length === 0 && !isVisible) {
    return null;
  }

  return (
    <div className={`live-log ${isVisible ? 'expanded' : 'collapsed'}`}>
      {/* Toggle button */}
      <button
        className="live-log-toggle"
        onClick={toggleVisible}
        title={isVisible ? 'Hide log' : 'Show log'}
      >
        {isVisible ? '▼' : '▲'} Log {messages.length > 0 && `(${messages.length})`}
      </button>

      {/* Messages - only show when visible */}
      {isVisible && (
        <div className="live-log-messages">
          {messages.map((msg, index) => (
            <div
              key={msg.id}
              className={`log-message log-${msg.level} ${index === messages.length - 1 ? 'newest' : ''}`}
              style={{
                animationDelay: `${index * 0.05}s`,
              }}
            >
              <span className="log-timestamp">
                {new Date(msg.timestamp).toLocaleTimeString('en-US', {
                  hour: '2-digit',
                  minute: '2-digit',
                  second: '2-digit',
                  hour12: false,
                })}
              </span>
              <span className="log-text">{msg.message}</span>
            </div>
          ))}
          <div ref={messagesEndRef} />
        </div>
      )}
    </div>
  );
};

export default LiveLog;
